const docSubSearchFormStyle = theme => ({
	root: {
		'& .MuiTextField-root': {
			marginTop: theme.spacing(2),
		},
	},

	datePickerField: {
		marginBottom: theme.spacing(0),
		width: '49%',
	},

	searchBtn: {
		paddingTop: theme.spacing(2),
		paddingBottom: theme.spacing(5)
	},

	resultMsg: {
		paddingLeft: theme.spacing(2),
		paddingBottom: theme.spacing(2),
	},

	searchField: {
		width: "49%"
	}

})


export {docSubSearchFormStyle}